import { createSlice } from '@reduxjs/toolkit';
import { getUsers } from '../thunks/userThunk';

const initialState = {
  list: [],
  total: 0,
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    updateUserRow: (state, action) => {
      const updatedUser = action.payload;
      const index = state.list.findIndex(user => user._id === updatedUser._id);
      if (index !== -1) {
        state.list[index] = { ...state.list[index], ...updatedUser };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.list = action.payload.data;
        state.total = action.payload.total;
        state.loading = false;
      })
      .addCase(getUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { updateUserRow } = userSlice.actions;
export default userSlice.reducer;